import angular from 'angular'
import { inputTaxType } from 'redevConfig'

const list = (inputTaxType && inputTaxType.list) || ''

const inputTaxTypeTemp = list ? require(`redevelopment/input/inputTaxType/${list.templateName}`) : require('./view/inputTaxType.html')
const inputTaxTypeCtrl = list ? require(`redevelopment/input/inputTaxType/${list.controllerName}`) : require('./inputTaxTypeCtrl')

export default angular
    .module('input.basedata.inputTaxType', [])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('input.basedata.inputTaxType', {
                url: '/inputTaxType',
                abstract: true,
                template: '<div ui-view></div>',
                default: 'input.basedata.inputTaxType.list',
                title: '规则配置',
            })
        $stateProvider.state('input.basedata.inputTaxType.list', {
            url: '/list',
            template: inputTaxTypeTemp,
            controller: 'inputTaxTypeCtrl',
        })
    }]).controller('inputTaxTypeCtrl', inputTaxTypeCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/input/basedata/inputTaxType/index.js